import qsRequest from "@/api/qsRequest";

export async function getConfig(key: string) {
    const res = await qsRequest({
        method: "get",
        url: "/config",
         params: {
            key: key,
        }
    })
    const {data} = res.data
    return {
        config: data
    }
}